"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunityScheduledShiftDto = instanceOfOrientationOpportunityScheduledShiftDto;
exports.OrientationOpportunityScheduledShiftDtoFromJSON = OrientationOpportunityScheduledShiftDtoFromJSON;
exports.OrientationOpportunityScheduledShiftDtoFromJSONTyped = OrientationOpportunityScheduledShiftDtoFromJSONTyped;
exports.OrientationOpportunityScheduledShiftDtoToJSON = OrientationOpportunityScheduledShiftDtoToJSON;
exports.OrientationOpportunityScheduledShiftDtoToJSONTyped = OrientationOpportunityScheduledShiftDtoToJSONTyped;
const ProfileNameDto_1 = require("./ProfileNameDto");
const ShiftStatus_1 = require("./ShiftStatus");
/**
 * Check if a given object implements the OrientationOpportunityScheduledShiftDto interface.
 */
function instanceOfOrientationOpportunityScheduledShiftDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('nurseProfile' in value) || value['nurseProfile'] === undefined)
        return false;
    return true;
}
function OrientationOpportunityScheduledShiftDtoFromJSON(json) {
    return OrientationOpportunityScheduledShiftDtoFromJSONTyped(json, false);
}
function OrientationOpportunityScheduledShiftDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'status': (0, ShiftStatus_1.ShiftStatusFromJSON)(json['status']),
        'nurseProfile': (0, ProfileNameDto_1.ProfileNameDtoFromJSON)(json['nurseProfile']),
    };
}
function OrientationOpportunityScheduledShiftDtoToJSON(json) {
    return OrientationOpportunityScheduledShiftDtoToJSONTyped(json, false);
}
function OrientationOpportunityScheduledShiftDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
        'status': (0, ShiftStatus_1.ShiftStatusToJSON)(value['status']),
        'nurseProfile': (0, ProfileNameDto_1.ProfileNameDtoToJSON)(value['nurseProfile']),
    };
}
//# sourceMappingURL=OrientationOpportunityScheduledShiftDto.js.map